export default {
  List: {
    ActionColumn: 'Chức năng',
  },
};
